module.exports = __webpack_public_path__ + "static/media/Contract Manufacturers Infographic - Mobile - 16-04-2025 C.871b9411.gif";